import axiosInstance from './axios';

export interface UserProfile {
  id: string;
  fullName: string;
  mobileNumber: string;
  email?: string;
  gender?: string;
  dateOfBirth?: string;
  taluka?: string;
  village?: string;
  pincode?: string;
}

export interface UpdateUserProfileRequest {
  email?: string | null;
  fullName?: string | null;
  gender?: string | null;
  taluka?: string | null;
  village?: string | null;
  pincode?: string | null;
  dateOfBirth?: string | null;
  mobileNumber?: string | null;
  cropAcreage?: string | null;
}

export const userApi = {
  getUserProfile: async (userId: string) => {
    const response = await axiosInstance.get(`/users/${userId}`);
    return response.data;
  },

  updateUserProfile: async (userId: string, data: UpdateUserProfileRequest & { profileImage?: File | string }) => {
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      if (key === 'profileImage' && value) {
        // If profileImage is a base64 string, convert to Blob
        let fileToUpload: File | Blob | string = value;
        if (typeof value === 'string' && value.startsWith('data:image/')) {
          const arr = value.split(',');
          // Use a more efficient regex pattern that avoids backtracking
          const mimeMatch = arr[0].match(/^data:([^;]+);/);
          const mime = mimeMatch ? mimeMatch[1] : '';
          if (mime) {
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            fileToUpload = new Blob([u8arr], { type: mime });
          }
        }
        formData.append('profileImage', fileToUpload);
      } else {
        // For all other fields, append the value (including null)
        formData.append(key, value === null ? 'null' : (value as string));
      }
    });
    const response = await axiosInstance.put(`/users/${userId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
}; 